module.exports = __webpack_public_path__ + "img/85.c68b54cb.jpg";